module.exports = __webpack_public_path__ + "img/cep-telefonu-sigortasi.0e4708b3.png";